var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0ZM24 1.73494C36.2966 1.73494 46.2651 11.7033 46.2651 24C46.2651 36.2966 36.2966 46.2651 24 46.2651C11.7033 46.2651 1.73494 36.2966 1.73494 24C1.73494 11.7033 11.7033 1.73494 24 1.73494Z",
    fill: "#146EB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2831 15.3331C17.2831 14.6152 17.8652 14.0331 18.5831 14.0331H29.4165C30.1344 14.0331 30.7165 14.6152 30.7165 15.3331V32.6665C30.7165 33.3844 30.1344 33.9665 29.4165 33.9665H18.5831C17.8652 33.9665 17.2831 33.3844 17.2831 32.6665V15.3331ZM18.5831 12.2998C16.9079 12.2998 15.5498 13.6579 15.5498 15.3331V32.6665C15.5498 34.3417 16.9079 35.6998 18.5831 35.6998H29.4165C31.0917 35.6998 32.4498 34.3417 32.4498 32.6665V15.3331C32.4498 13.6579 31.0917 12.2998 29.4165 12.2998H18.5831ZM23.9998 28.8748C23.1023 28.8748 22.3748 29.6023 22.3748 30.4998C22.3748 31.3973 23.1023 32.1248 23.9998 32.1248H24.0106C24.9081 32.1248 25.6356 31.3973 25.6356 30.4998C25.6356 29.6023 24.9081 28.8748 24.0106 28.8748H23.9998Z",
    fill: "#146EB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApk);
export default __webpack_public_path__ + "static/media/apk.c20a204a6f5663e1b5f9cf8b5cde8881.svg";
export { ForwardRef as ReactComponent };